<template>
  <div class="input">
    <div class="input-label">終了時間</div>
    <div class="input-group">
      <input
        type="number"
        min="0"
        max="23"
        class="input-text"
        v-model="finishHour"
        disabled
        >

      <div class="input-label_after">時</div>

      <input
        type="number"
        min="0"
        max="59"
        class="input-text"
        v-model="finishMinute"
        disabled
        >

      <div class="input-label_after">分</div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    finishHour: {
      get: function () {
        return this.$store.state.eventClosed.finishHour
      },
      set: function (value) {
        this.$store.commit(
          'eventClosed/setFinishHour',
          value
        )
      }
    },

    finishMinute: {
      get: function () {
        return this.$store.state.eventClosed.finishMinute
      },
      set: function (value) {
        this.$store.commit(
          'eventClosed/setFinishMinute',
          value
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss';
</style>
